import { render, staticRenderFns } from "./ProjectValuationSummaryBuyersDataTable.vue?vue&type=template&id=3638b4b8&"
import script from "./ProjectValuationSummaryBuyersDataTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectValuationSummaryBuyersDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports